import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FinancialAccount, TrackingOption } from '@portal-front-end/models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })
export class FinancialAccountsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    getAllAccounts(): Observable<FinancialAccount[]> {
        return this.http.get<FinancialAccount[]>(`${this.apiServer}/xero-contacts`);
    }

    getAccountById(id: string): Observable<FinancialAccount> {
        return this.http.get<FinancialAccount>(`${this.apiServer}/xero-contacts/${id}`);
    }

    getAllTrackingOptions() : Observable<TrackingOption[]> {
        return this.http.get<TrackingOption[]>(`${this.apiServer}/xero-tracking`)
        .pipe(map(options => {
            return options.map(this.fillInRenderName)
        }));
    }

    getTrackingById(id: string): Observable<TrackingOption> {
        return this.http.get<TrackingOption>(`${this.apiServer}/xero-tracking/${id}`)
        .pipe(map(this.fillInRenderName));
    }

    private fillInRenderName(option: TrackingOption): TrackingOption{
        return {
            ...option,
            name: `${option.trackingCategoryName} - ${option.trackingOptionName}`
        }
    }
}